import { isConfigReport, isUnifiedAnalyticsReport, isUnifiedEventsQLReport, isUnifiedEventsReport } from './../tsTypes/reportTypes';
import { getDataType, getFilterGroups, getReportConfig } from '../report/configReportGetters';
import { CRM_SEARCH_FILTERS_V2_UEQL_REPORTS } from '../constants/gates';
import { DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES } from '../constants/objectCoordinates';
import { isExternalDataType } from './../report/externalReportGetters';
import { ENGAGEMENT } from '../constants/dataTypes';
export const areFilterGroupsSupported = (report, userInfo) => {
  if (!isConfigReport(report)) {
    return false;
  }

  // Reports with existing filter groups should enable the filtersV2 experience
  const filterGroups = getFilterGroups(getReportConfig(report));
  if (filterGroups && filterGroups.size > 0) {
    return true;
  }
  if (isUnifiedAnalyticsReport(report)) {
    return true;
  } else if (isUnifiedEventsQLReport(report)) {
    return userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates.includes(CRM_SEARCH_FILTERS_V2_UEQL_REPORTS);
  }
  const dataType = getDataType(report);
  if (isExternalDataType(dataType)) {
    return true;
  }
  if (!isUnifiedEventsReport(report)) {
    // UE reports dataType does not resolve to ObjectTypeId
    if (!(dataType !== null && dataType !== void 0 && dataType.match(/^\d-\d+$/) ||
    // dataType is in ObjectTypeId format
    DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES.get(dataType) || dataType === ENGAGEMENT) // Can be converted to ObjectTypeId
    ) {
      return false;
    }
  }
  return true;
};